<template>
  <div class="tableTemplate">
    <!-- 标签列表 -->
    <div class="release-list">
      <div class="release-list-header">
        <div
          class="release-list-header-item"
          :class="item.key"
          v-for="item in column"
          :key="item.key"
        >
          {{ item.title }}
        </div>
        <div class="release-list-header-item operating" :style="{ width: width + 'px' }">操作</div>
      </div>
      <div class="release-list-body" :style="{ ...tableBodyStyle }" v-loading="tableLoading">
        <!-- 暂无数据 -->
        <div v-if="tableData.length === 0" class="release-list-noData">
          <img
            v-if="!isChooseTable"
            class="release-list-noData-img"
            src="https://vfiles.gtimg.cn/vupload/20200731/ebbb101596195648710.png"
          />
          <div
            class="release-list-noData-word"
            :style="isChooseTable ? { marginTop: '180px' } : ''"
          >
            暂无相关内容
          </div>
        </div>
        <!-- 有数据 -->
        <div v-else class="release-Strategy">
          <template v-if="isChooseTable">
            <div
              v-for="(item, index) in tableData"
              :key="item.id"
              :ref="'tableRow' + index"
              :class="
                item.active
                  ? 'release-Strategy-normal table-line-active'
                  : 'release-Strategy-normal'
              "
              @click.prevent="tableRowClickFun(index, item, $event)"
              @mouseenter.prevent="tableRowMouseEnterFun(index, item, $event)"
              @mouseleave.prevent="tableRowMouseLeaveFun(index, item, $event)"
            >
              <div
                v-for="(value, name) in renderData(item, column)"
                class="Strategy-time overflowEllipsis"
                :key="name"
              >
                <!-- enabled=0的时候是禁用, 禁用状态颜色置灰 -->
                <div
                  v-if="
                    getCurrentrender(name, column) && getCurrentrender(name, column)(value, item)
                  "
                  class="overflowItem"
                  :style="item.enabled === 0 ? 'color:#C0C4CC' : 'color:#606266'"
                  v-html="getCurrentrender(name, column)(value, item)"
                />
                <div
                  class="overflowItem"
                  :style="item.enabled === 0 ? 'color:#C0C4CC' : 'color:#606266'"
                  v-else
                >
                  {{ value }}
                </div>
              </div>
              <div class="Strategy-time operating" :style="{ width: width + 'px' }">
                <slot :item="item" :index="index" />
              </div>
            </div>
          </template>
          <template v-else>
            <div v-for="(item, index) in tableData" class="release-Strategy-normal" :key="item.id">
              <div
                v-for="(value, name) in renderData(item, column)"
                class="Strategy-time overflowEllipsis"
                :key="name"
              >
                <!-- enabled=0的时候是禁用, 禁用状态颜色置灰 -->
                <div
                  v-if="
                    getCurrentrender(name, column) && getCurrentrender(name, column)(value, item)
                  "
                  class="overflowItem"
                  :style="item.enabled === 0 ? 'color:#C0C4CC' : 'color:#606266'"
                  v-html="getCurrentrender(name, column)(value, item)"
                />
                <div
                  class="overflowItem"
                  :style="item.enabled === 0 ? 'color:#C0C4CC' : 'color:#606266'"
                  v-else
                >
                  {{ value }}
                </div>
              </div>
              <div class="Strategy-time operating" :style="{ width: width + 'px' }">
                <slot :item="item" :index="index" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="release-page">
      <!-- v-if="pagination.tableTotal-pagination.tablePageSize > 0" -->
      <el-pagination
        v-if="!isChooseTable"
        class="release-pagination"
        layout="total, prev, pager, next, jumper"
        :total="pagination.tableTotal"
        :page-size="pagination.tablePageSize"
        :current-page="currentPage"
        @current-change="currentChangeFun"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableTemplate',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    column: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    noPages: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 256,
    },
    pagination: {
      type: Object,
      default: () => ({
        tableTotal: 0,
        tablePageSize: 0,
      }),
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
    // 是否能点击表格
    isChooseTable: {
      type: Boolean,
      default: false,
    },
    tableBodyStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableData: this.data,
    };
  },
  watch: {
    data: {
      handler(newVal) {
        this.tableData = newVal;
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    /* 分页 */
    currentChangeFun(val) {
      this.$emit('paginationEmit', val);
      this.$emit('update:currentPage', val);
    },
    /* 获取每个item的render方法 */
    getCurrentrender(name, column) {
      const selected = column.filter((item) => item.key == name);
      return selected[0].render || null;
    },
    /* 筛选渲染表格row数据 */
    renderData(item, column) {
      const arr = column.map((item) => item.key);
      const obj = {};
      arr.forEach((val) => {
        for (const key in item) {
          if (val == key) {
            obj[key] = item[key];
          }
        }
      });
      return obj;
    },
    // 表格行点击选中事件
    tableRowClickFun(index, item) {
      // $event.preventDefault();

      // 数据驱动
      const { tableData } = this;
      for (let i = 0, ilen = tableData.length; i < ilen; i++) {
        tableData[i].active = false;
      }
      tableData[index].active = true;

      this.tableData = tableData;
      this.$forceUpdate();

      // dom操作
      const curTableRow = this.$refs[`tableRow${index}`][0];
      // curTableRow.parentNode.childNodes.forEach(item => {//清空其他选中项
      //     item.classList.remove('table-line-active')
      //     //判断是否存在左右移动
      //     if (item.lastChild.lastChild.hasAttribute('data-move')) {
      //         item.lastChild.lastChild.classList.remove('table-line-active')
      //     }
      // });
      // curTableRow.classList.add('table-line-active')
      // if (curTableRow.lastChild.lastChild.hasAttribute('data-move')) {
      //     curTableRow.lastChild.lastChild.classList.add('table-line-active')
      // }

      this.$emit('tableRowEmit', { item, curTableRow });
    },
    // 表格行点击移入事件
    tableRowMouseEnterFun() {
      // $event.preventDefault();
      // let curTableRow = (this.$refs['tableRow' + index])[0]
      // curTableRow.style.cursor = 'pointer'
      // curTableRow.classList.add('table-line-temp')
      // if (curTableRow.lastChild.lastChild.hasAttribute('data-move')) {
      //     curTableRow.lastChild.lastChild.classList.add('table-line-temp')
      // }
    },
    // 表格行点击移出事件
    tableRowMouseLeaveFun() {
      // $event.preventDefault();
      // let curTableRow = (this.$refs['tableRow' + index])[0]
      // curTableRow.classList.remove('table-line-temp')
      // if (curTableRow.lastChild.lastChild.hasAttribute('data-move')) {
      //     curTableRow.lastChild.lastChild.classList.remove('table-line-temp')
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
